/* ============================================================================
   JuiceBox Super Summer Sale 2026 — home-page teaser behavior
   Companion to snippets/jb-sss-home-teaser.liquid (see its header docs).
   Modules: end-of-sale watchdog, ARIA tabs, slider stepping.
   Everything is namespaced data-ssst-* / .jb-ssst__ — deliberately disjoint
   from the sale page's data-sss-* so both modules can never collide.
   ========================================================================== */
(function () {
  var root = document.querySelector('.jb-ssst');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ==================== End-of-sale watchdog ==================== */
  // No before-state: the merchant mounts the section only while the sale
  // should show. This tick only hides the module the moment the sale ends
  // on an already-open page (server-side, an ended sale renders nothing).
  var endMs = parseInt(root.getAttribute('data-ssst-end'), 10) * 1000;
  var tickTimer = setInterval(function () {
    if (Date.now() <= endMs) return;
    root.hidden = true;
    clearInterval(tickTimer);
  }, 1000);

  /* ==================== Sliders (arrow stepping) ==================== */
  var sliders = {};

  function initSlider(vp) {
    var track = vp.querySelector('.jb-ssst__track');
    var prev = root.querySelector('[data-ssst-prev="' + vp.id + '"]');
    var next = root.querySelector('[data-ssst-next="' + vp.id + '"]');

    function cardWidth() {
      var first = track && track.children[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    // Arrow enabled/disabled state at the scroll ends. Hidden panels measure
    // 0, so this must be re-run on tab reveal and resize, never only at init.
    function refresh() {
      if (!prev || !next) return;
      var max = vp.scrollWidth - vp.clientWidth;
      var scrollable = max > 1;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      prev.disabled = vp.scrollLeft <= 1;
      next.disabled = vp.scrollLeft >= max - 1;
    }

    function step(dir) {
      vp.scrollBy({
        left: cardWidth() * dir,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var raf = null;
    vp.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          refresh();
        });
      },
      { passive: true }
    );

    refresh();
    sliders[vp.id] = { refresh: refresh };
  }

  Array.prototype.forEach.call(root.querySelectorAll('.jb-ssst__vp'), initSlider);

  /* ==================== ARIA tabs ==================== */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ssst-tab]'));
  var panels = root.querySelectorAll('[data-ssst-panel]');

  function selectTab(key, focusIt) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-ssst-tab') === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && focusIt) tab.focus();
    });
    Array.prototype.forEach.call(panels, function (panel) {
      panel.hidden = panel.getAttribute('data-ssst-panel') !== key;
    });
    // The freshly revealed viewport could not be measured while hidden.
    if (sliders['ssst-vp-' + key]) sliders['ssst-vp-' + key].refresh();
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      selectTab(tab.getAttribute('data-ssst-tab'), false);
    });
    tab.addEventListener('keydown', function (e) {
      var target = null;
      if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') target = tabs[0];
      else if (e.key === 'End') target = tabs[tabs.length - 1];
      if (!target) return;
      e.preventDefault();
      selectTab(target.getAttribute('data-ssst-tab'), true);
    });
  });

  /* Resize: card widths and scrollable-ness change with the viewport. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var id in sliders) sliders[id].refresh();
    }, 150);
  });
})();
